import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import * as ManagedEquipmentDropDownType from '../../Store/AssetManagement/ManagedEquipmentDropDown/ManagedEquipmentDropDownType'
import {setManagedEquipmentDropDown } from '../../Store/AssetManagement/ManagedEquipmentDropDown/ManagedEquipmentDropDownAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getManagedEquipmentDropDown(val: any): any {
    let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/dropdown/${val.assetSubTypeId}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Drop Down values...."));

        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if(response?.length > 0){
            yield put (setManagedEquipmentDropDown(response))
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(
            setManagedEquipmentDropDown([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetEquipmentTypes() {
    yield takeEvery(ManagedEquipmentDropDownType.GET_MANAGED_EQUIPMENT_DROP_DOWN, getManagedEquipmentDropDown)
}

export default function* combinedSaga() {
    yield all([
        watchGetEquipmentTypes()
    ])
}
